<template>
  <div>
    <el-form ref="formRef" :model="msgForm" label-width="88px">
      <el-form-item label="城市：">
        <el-select v-model="province" placeholder="Select" style="width: 11.5em;margin-right: 1em" @change="changeCity" >
          <el-option v-for="item in provinceList" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
        <el-select v-model="city" placeholder="Select" style="width: 11.5em">
          <el-option v-for="item in cityList" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="消息内容：">
        <el-input :rows="4" type="textarea" v-model="msgForm.msg" placeholder="输入消息内容" style="width:24em;"/>
      </el-form-item>
    </el-form>
    <div class="dialog-footer" style="text-align: center">
      <el-button @click.native="cancel" >取消</el-button>
      <el-button type="primary" @click="summit" v-loading="loading">确定</el-button>
    </div>
  </div>

</template>

<script>
import { postFormData, getFormData } from "@/api/api"
import { addOrUpdateMatcherMsg,areaList } from "@/api/url";

export default {
  name: "TagManageDialog",
  props: {
    value: Object
  },
  data() {
    return {
      msgForm: this.value.msgForm,
      idx: this.value.ids,
      loading: false,

      province: this.value.msgForm.province?this.value.msgForm.province:'-1',
      city: this.value.msgForm.city?this.value.msgForm.city:'-1',
      provinceList: [
        {label: '不限', value: '-1'}
      ],
      cityList: [],

    }
  },
  methods: {
    cancel() {
      this.$emit("close");
    },

    //更改或添加
    headImgUpdate() {
      this.$refs.headImg.click();
    },

    //选取图片
    headImgChanged(e) {
      if(e.target.files[0]) {
        this.files = e.target.files[0];
        var windowURL = window.URL || window.webkitURL;
        this.src = windowURL.createObjectURL(this.files);
      }
    },

    summit() {
      if(!this.msgForm.msg) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '内容不能为空',
          type: 'warning'
        });
        return false
      }
      this.loading = true
      let _this = this
      let param = {};
      param['id'] = this.msgForm.id?this.msgForm.id:0;
      param['msg'] = this.msgForm.msg;
      param['province'] = this.province;
      param['city'] = this.city;
      postFormData(addOrUpdateMatcherMsg, param).then((data) => {
        let {msg, code} = data
        if (code == 200) {
          _this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'success'
          });
          _this.$emit('confirm')
        }else {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'warning'
          });
        }
        _this.loading = false
      }).catch(()=>{
        _this.loading = false
      })
    },

    changeCity() {
      this.cityList = []
      if(this.province == -1) {
        this.cityList.push({label:'不限', value: '-1'})
      }else {
        for(let i=0; i<this.provinceList.length; i++) {
          if (this.province == this.provinceList[i].province) {
            let citys = this.provinceList[i].cityList
            citys.forEach(item => {
              let obj = {}
              obj.label = item.city
              obj.value = item.city
              this.cityList.push(obj)
            })
          }
        }
      }
      this.city = this.cityList[0].value
    },

    getAreaList() {
      getFormData(areaList).then((data)=>{
        let {msg, code} = data
        if (code == 200) {
          let dataList = data.data
          dataList.forEach(item => {
            item.label = item.province
            item.value = item.province
          })
          this.provinceList = this.provinceList.concat(dataList);
          if(this.province == -1) {
            this.cityList.push({label:'不限', value: '-1'})
          }else {
            for(let i=0; i<this.provinceList.length; i++) {
              if (this.province == this.provinceList[i].province) {
                let citys = this.provinceList[i].cityList
                citys.forEach(item => {
                  let obj = {}
                  obj.label = item.city
                  obj.value = item.city
                  this.cityList.push(obj)
                })
              }
            }
          }
        }else {
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
      })
    },

  },
  mounted() {
    this.getAreaList()
  }
}
</script>

<style scoped>
.add {
  width: 80px;
  height: 80px;
  text-align: center;
  line-height: 80px;
  border: 1px dashed #ececec;
  font-size: 30px;
  cursor: pointer;
  float: left;
}
</style>
